<template>
    <div id="scanner_setting_operations">
        <div v-if="operations.length">
            <h3>
                <!-- 共有 {{ operations.length }} 件委託單，{{ sum_core_waybills }} 貨 -->
                {{
                    $t('ui.scanner.operations.total', {
                        operations_length: operations.length,
                        sum_core_waybills: sum_core_waybills
                    })
                }}
            </h3>
        </div>

        <div
            v-if="operations.length"
            v-for="operation in operations"
            @click.prevent="set_current_operation(operation)"
            :class="{active: current_customer_operation.identity == operation.identity}"
            class="ui segment pointer operation">
            <h3 style="margin-bottom: 3px;">
                {{ operation.number }}
                <span class="sub_title">
                    <span v-if="operation.customer">
                        [{{ operation.customer.company_name}}]
                    </span>
                    <span>
                        / {{ operation.core_waybills.length }}件
                    </span>
                </span>
            </h3>
            <div class="content" v-html="operation.provider_note">
            </div>

            <div class="core_waybills" v-if="current_customer_operation.identity == operation.identity">
                <span>
                    <!-- 內容運單： -->
                    {{ $t('ui.scanner.operations.contents') }}：
                    <span v-for="(number, index) in sort_operation_core_waybills_numbers">
                        {{ number }}
                        <span v-if="sort_operation_core_waybills_numbers.length != index+1">
                            /
                        </span>
                    </span>
                </span>
            </div>
        </div>
        <div v-if="!operations.length"
            class="ui segment pointer operation">
            <h3 :style="{color: theme.color.font}">
                <!-- 您目前沒有任何訂單 -->
                {{ $t('ui.scanner.helps.you_dont_any_operation') }}
            </h3>
        </div>

        <div class="refresh_operations_icon"
            @click="$store.dispatch('customer/fetch_current_customer_operations')">
            <i class="icon big refresh pointer"></i>
        </div>

    </div>
</template>

<script>
export default {
    props: {
        is_inverted: {
            default: false,
            type: Boolean
        },
    },
    data() {
        return {
            is_setting: false,
            core_waybill_identities: [],
        }
    },
    computed: {
        current_store() {
            return this.$store.state[this.$store.state.current_scope].scanner_module
        },
        theme() {
            return this.current_store.config.theme
        },
        operations() {
            return this.$store.state.customer.customer_operations
        },
        current_customer_operation() {
            return this.$store.state.customer.customer_operation
        },
        sort_operation_core_waybills_numbers() {
            var result = _.map(this.current_customer_operation.core_waybills, 'number') || []
            return result.sort().reverse()
        },
        sum_core_waybills() {
            return _.sumBy(this.operations, (operation) => {
                return operation.core_waybills.length
            })
        },
    },
    watch: {
    },
    mounted() {
        this.$store.dispatch('customer/fetch_current_customer_operations')
    },
    methods: {
        set_current_operation(operation) {
            if (operation.identity == this.current_customer_operation.identity) {
                // "已清空當前訂單"
                this.$noty.warning(
                    this.$t('ui.scanner.operations.clear_current_operation')
                , 200)
                this.$store.dispatch('customer/set_current_customer_operation', {})
            } else {
                // "已設定當前訂單為 "
                this.$noty.success(
                    this.$t('ui.scanner.operations.current_operation_set_to') + ' ' +
                    operation.number
                , 300)
                this.$store.dispatch('customer/set_current_customer_operation', operation)
            }
        },
    },
    components: {
    },
}
</script>

<style lang="scss" scoped>
#scanner_setting_operations {
    & {
        position: relative;
        padding-left: 30px;
        padding-right: 30px;
    }
    .refresh_operations_icon {
        position: absolute;
        top: 0;
        right: 14px;
        z-index: 2;
    }
    .segment.operation {
        &:first-child {
            border-top: 0px white solid;
        }
        & {
            background: none;
            z-index: 1;
            padding: 6px;
            color: white;
            border-top: 1px #666 solid;
            border-top-right-radius:0px;
            border-top-left-radius:0px;
        }
        &.active {
            border: 2px white solid;
            border-radius: .28571429rem;
        }
        &.active + div {
            border-top: 0px white solid;
        }
        .core_waybills, .content {
            padding-left: 12px;
        }
        .content {
            color: rgba(255,255,255,.7);
        }
    }

    .dropdown.inverted {
        &, .text:not(.default) {
            color: white !important;
        }
        .item {
            color: white ;
        }
    }
    .sub_title {
        font-size: small;
    }
}
@media only screen and (max-width: 767px) {
    #scanner_setting_operations {
        & {
            max-height: 60vh;
            overflow-x: hidden;
            overflow-y: scroll;
            padding-left: 2rem;
            padding-right: 2rem;
        }
        .sub_title {
            display: block;
            padding-left: 12px;
        }
    }
}
</style>
